import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from "./translation/en.json";
import de from "./translation/de.json";

const backend = new Backend({
  // path where resources get loaded from
  loadPath: '/locales/{{lng}}/{{ns}}.json'
});

//i18n
//  .use(backend)
//  .use(LanguageDetector)
//  .use(initReactI18next)
//  .init({
//    fallbackLng: 'en',
//    debug: true,

//    interpolation: {
//      escapeValue: false, // not needed for react as it escapes by default
//    }
//  });


//---Using different namespaces
const resources = {
    en: {
        translation: en,
    },
    de: {
        translation: de,
    },
}

i18n
.use(LanguageDetector)
.use(initReactI18next)
.init({
  resources,
  fallbackLng: 'de',
  debug: true,
  interpolation:{
		escapeValue:false 
	}
});

export default i18n;